module.exports = __webpack_public_path__ + "static/media/icon_occlusal_surface_3.b72d3880.svg";